export enum BeneficiaryRelationshipType {
    SPOUSE = 'Spouse',
    CHILD = 'Child',
    PARENT = 'Parent',
    OTHER = 'Other'
}